import React from "react";

/**
 * Profit-style split layout: left = section pills + compact charts, right = main content.
 */
export function LoungeViewPills({ items = [], activeKey, onSelect, ariaLabel = "Section views" }) {
  let lastGroup = null;
  return (
    <div className="analytics-lounge-pills" role="tablist" aria-label={ariaLabel}>
      {items.map((item) => {
        const showGroup = item.group && item.group !== lastGroup;
        if (item.group) lastGroup = item.group;
        const active = activeKey === item.key;
        return (
          <React.Fragment key={item.key}>
            {showGroup ? <p className="analytics-lounge-pills__group">{item.group}</p> : null}
            <button
              type="button"
              role="tab"
              aria-selected={active}
              className={`analytics-lounge-pill${active ? " analytics-lounge-pill--active" : ""}`}
              onClick={() => onSelect(item.key)}
            >
              <span className="analytics-lounge-pill__label">{item.label}</span>
              {item.badge != null && item.badge !== "" ? (
                <span className="analytics-lounge-pill__badge">{item.badge}</span>
              ) : null}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default function AnalyticsLoungeDashboard({
  title,
  subtitle,
  toolbar = null,
  pillItems = [],
  activePill,
  onPillSelect,
  charts = null,
  showCharts = true,
  mainHeader = null,
  children,
  className = "",
}) {
  const hasPills = pillItems.length > 0;
  const hasCharts = showCharts && charts;
  const hasSide = hasPills || hasCharts;
  const gridClass = [
    "analytics-lounge-dashboard__grid",
    !hasCharts ? "analytics-lounge-dashboard__grid--no-charts" : "",
    !hasPills ? "analytics-lounge-dashboard__grid--no-pills" : "",
    !hasSide ? "analytics-lounge-dashboard__grid--main-only" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={`analytics-lounge-dashboard pb-lounge-card admin-console-card p-0 border-0 overflow-hidden ${className}`.trim()}>
      <div className="analytics-lounge-dashboard__toolbar px-3 px-lg-4 pt-3 pb-2">
        <div className="d-flex flex-wrap align-items-end justify-content-between gap-3">
          <div>
            <h3 className="h5 mb-1 tracking-tight text-white">{title}</h3>
            {subtitle ? <p className="text-secondary small mb-0">{subtitle}</p> : null}
          </div>
          {toolbar ? <div className="d-flex flex-wrap gap-2 align-items-end">{toolbar}</div> : null}
        </div>
      </div>

      <div className={gridClass}>
        {hasSide ? (
          <aside className="analytics-lounge-dashboard__side">
            {hasPills ? (
              <LoungeViewPills items={pillItems} activeKey={activePill} onSelect={onPillSelect} ariaLabel={title} />
            ) : null}
            {hasCharts ? <div className="analytics-lounge-dashboard__charts">{charts}</div> : null}
            {hasPills && !hasCharts ? (
              <p className="text-secondary small mb-0 px-1">Select a section — details appear on the right.</p>
            ) : null}
          </aside>
        ) : null}

        <main className="analytics-lounge-dashboard__main">
          {mainHeader}
          {children}
        </main>
      </div>
    </div>
  );
}
